const { Type } = require('@sinclair/typebox');
const { moduleRegistration } = require('@sstdev/lib_metadata-config');

/** Builds the TypeBox schema fragment for the Password form element. */
function asDataDictionary(hNode, context) {
    const { id, title, propertyName, required } = hNode;
    //This block tells us nothing about namespaces/relations
    const subDataDictionary = {};

    const { isOptional: optional, schemaOptions } = moduleRegistration.resolveFieldFlags(required, context);

    // Helper to wrap a schema as optional if needed
    const maybeOptional = schema => (optional ? Type.Optional(schema) : schema);

    // Build the string schema with password format (using x-format since 'password' is not a standard JSON Schema format)
    // https://www.learnjsonschema.com/2020-12/format-annotation/format/
    const stringOptions = {
        title: title,
        'x-format': 'password',
        'x-id': id,
        'x-dataType': 'string',
        'x-propertyName': propertyName,
        ...schemaOptions
    };

    const passwordSchema = maybeOptional(Type.String(stringOptions));

    // The partial type definition is a plain object with the property schema
    const partialTypeDefinition = {
        [propertyName]: passwordSchema
    };

    return [subDataDictionary, partialTypeDefinition];
}

module.exports = { asDataDictionary };
